import { useEffect, useState } from "react";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import { Box, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";

type Props = {
  onEditHandler: (id?: number) => void;
  onDeleteHandler: (id?: number) => void;
};

const useSetAttributeColumnDefs = (
  onEditHandler: Props["onEditHandler"],
  onDeleteHandler: Props["onDeleteHandler"]
) => {
  const { t } = useTranslation();
  const [columnDefs, setColumnDefs] = useState<ColDef[]>([]);

  useEffect(() => {
    setColumnDefs([
      {
        field: "name_th",
        headerName: t("inventory.items.set_attribute_name"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "remark",
        headerName: t("setting.description"),
        filter: "agTextColumnFilter",
        flex: 1,
        minWidth: 200,
      },
      {
        field: "",
        filter: false,
        sortable: false,
        width: 100,
        cellStyle: {
          display: "flex",
          justifyContent: "center",
        },
        cellRenderer: (params: ICellRendererParams) => {
          if (params.data) {
            return (
              <Box>
                <IconButton onClick={() => onEditHandler(params.data?.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton onClick={() => onDeleteHandler(params.data?.id)}>
                  <DeleteIcon />
                </IconButton>
              </Box>
            );
          }
        },
      },
    ]);
  }, [onDeleteHandler, onEditHandler, t]);

  return columnDefs;
};

export default useSetAttributeColumnDefs;
